/*
 * 選定支援事例 一覧 取得
 */
import { apiGetList } from '@/actions/ApiBaseActions';
export const API_GET_LIST_CASE = 'API_GET_LIST_CASE';
export const API_GET_LIST_CASE_RANKING = 'API_GET_LIST_CASE_RANKING';
/**
 * 選定支援事例一覧 取得
 */
export const apiGetListCase = ({ query: { category, is_top: isTop, page, price } }, meta) => apiGetList(API_GET_LIST_CASE, `/support_example`, { category, is_top: isTop, page, price }, Object.assign(Object.assign({}, meta), { isSnakeCase: true, requestPayload: { category, price } }));
/**
 * 選定支援事例ランキング一覧 取得
 */
export const apiGetListCaseRanking = (_data, meta) => apiGetList(API_GET_LIST_CASE_RANKING, `/support_example/ranking`, {}, Object.assign(Object.assign({}, meta), { isSnakeCase: true }));
